// import * as React from "react";
// import { PieChart } from "@mui/x-charts/PieChart";
// import { useDrawingArea } from "@mui/x-charts/hooks";
// import { styled } from "@mui/material/styles";

// const data = [
//   { value: 5, label: "Hyundai 1h 5min", color: "#21D59B", },
//   { value: 10, label: "Tata 1h 5min", color: "#F99600", },
// ];

// const size = {
//   width: 400,
//   height: 200,
// };

// const StyledText = styled("text")(({ theme }) => ({
//   fill: theme.palette.text.primary,
//   textAnchor: "middle",
//   dominantBaseline: "central",
//   fontSize: 14,
// }));

// function PieCenterLabel({ children }) {
//   const { width, height, left, top } = useDrawingArea();
//   return (
//     <StyledText x={left + width / 2} y={top + height / 2}>
//       {children}
//     </StyledText>
//   );
// }

// export default function PieChartWithCenterLabel() {
//   return (
//     <PieChart
//       series={[{ data, innerRadius: 80 }]}
//       {...size}
//     >
//       <PieCenterLabel>55hrs 30min</PieCenterLabel>
//     </PieChart>
//   );
// }


import Box from "components/common/Box";
import Card from "components/common/Card";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { makeStyles } from "@mui/styles";
import React from "react";
import { CircularProgress } from "@mui/material";

const PieChartWithCenterLabel = (props,minHeight='250px') => {
  const classes = useStyles();
  return (
    <>
      <Box sx={{ minHeight: minHeight }}>
        {props.isLoadingcustomerdata ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* <CircularProgress /> */}
          </Box>
        ) : (
          <>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
            </Stack>
            <HighchartsReact
              highcharts={Highcharts}
              options={props !== null ? props.options : " "}
            />
          </>
        )}
      </Box>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  HighchartsFirst: {
    "& .highcharts-container": {
      width: "100% !important",
    },
    "& .highcharts-root": {
      width: "100% !important",
    },
  },

  totalheading: {
    fontSize: "12px",
    color: "#7E84A3",
    fontWeight: "600",
    font: "Nunito Sans",
  },
  valueheading: {
    fontSize: "12px",
    color: "#545454",
    fontWeight: "600",
    font: "Nunito Sans",
  },
 rect: {
  "& .highcharts-point": {
    rx: 3,
    ry: 3
},
  },

}));

export default PieChartWithCenterLabel;

